import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatorioGerencialRcService {

  constructor( private readonly http : HttpClient ) { }

  public getAllEmpresas (idEmpresa) {
    return this.http.get( `/apiconnect/importation/company/group-company/${idEmpresa}/companies?tipOrdernamento=cnpjAsc` );
  }

  public getAllAnos (idEmpresa) {
    return this.http.get( `/apiconnect/importation/report/right-refill/years/${idEmpresa}/companies` );
  }

  public getAllFormatos () {
    return this.http.get( `/apiconnect/importation/report/right-refill/format-types` );
  }

  public postListaHtml( url, obj) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "text/html"
    });
    return this.http.post( `/apiconnect/report/rights-refills-reports/downloads${url}`, obj, { headers, observe: 'response',
      responseType: 'text', });
  }

  public postListaFormatos(url: string, obj: any ) {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.ms-excel"
    });
    return this.http.post( `/apiconnect/report/rights-refills-reports/${url}`, obj, 
      {
        headers,
        observe: 'response',
        responseType: 'blob'
      }
    );
  }
}
